import { useContext } from 'react';
import { DiilHeaderContext } from './DiilHeader';
const DIIL_LANGUAGES = [
    { id: 'et', label: 'estonian' },
    { id: 'ru', label: 'russian' }
];
const SUPER_LANGUAGES = [
    { id: 'et', label: 'estonian' },
    { id: 'ru', label: 'russian' },
    { id: 'en', label: 'english' }
];
const getHeaderLanguages = () => {
    const { brand } = useContext(DiilHeaderContext);
    const languages = brand === 'super' ? SUPER_LANGUAGES : DIIL_LANGUAGES;
    return {
        items: languages.map((lang) => mapLanguage(lang))
    };
};
const mapLanguage = (lang) => {
    const { navigate, translate, languageProps } = useContext(DiilHeaderContext);
    return {
        label: translate(`language.${lang.label}`),
        current: lang.id === languageProps.currentLanguage,
        url: `/${lang.id}/`,
        onClick: (event) => {
            event.preventDefault();
            navigate(event);
            languageProps.setLanguage(lang.id);
        }
    };
};
export { getHeaderLanguages };
//# sourceMappingURL=LanguageProvider.js.map